/**
 * Validation utilities for form fields using Zod
 *
 * Framework-agnostic validation that works in any environment.
 */
import { z } from 'zod';

export const isValidEmail = (email: string): boolean => {
  const result = z.string().email().safeParse(email);
  return result.success;
};

export const createEmailSchema = (
  message = 'Please enter a valid email address'
) => z.string().email({ message });

export const createRequiredStringSchema = (label: string) =>
  z.string().min(1, { message: `${label} is required` });
